import { useAuth0 } from "@auth0/auth0-react";
import { ReactComponent as AddIcon } from "assets/icons/add-plus.svg";
// import { getAccessTokenSilently, getLocalStorageItem } from "utils/functions";
import DeleteSvgComponent from "assets/icons/svg/DeleteSvg/Delete";
import { InputField, LabelField, MyCheckbox } from "components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from "helper/dateFormat";
import { ReactComponent as QuestionIcon } from '../../../../assets/icons/question-circle.svg';
import { CustomSelect } from "components/CustomSelect/CustomSelect";
import AlertDialog from "components/Dialog/index";
import AddInstallmentsPayment from "components/Installments/AddInstallmentsPayment";
import MyButton from "components/MyButton";
import { getCurrency } from "helper/numberFormat";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import thousands from "thousands";
import FinanceService from "../../../../Lib/API/Finance";
import { checkIsStripe } from "utils/checkIsStripe";
import { loadStripe } from "@stripe/stripe-js";
import { fontConfig } from "theme/fontConfig";


export const ACH = ({
  formik,
  onPaymentValueChange,
  title,
  setSelectedAch,
  selectedAch,
  setSelected,
  accountId,
  calculateTotalPaidAmount,
  calculateTotalAmount,
  allowPaymentInstallment,
  enablePaymentInstallments,
  source,
  setEnableAddCard,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  activeProvider,
  paymentMethodId,
  paymentGateway
}) => {
  const { getAccessTokenSilently } = useAuth0();
  const isMemberDetails = source === "updatePayments" || source === "managePayments";
  const isStripe = useMemo(() => checkIsStripe(paymentGateway), [paymentGateway]);
  console.log("isStripe", isStripe);
  // const enableInstallments = useMemo(() => allowPaymentInstallment && enablePaymentInstallments, [allowPaymentInstallment, enablePaymentInstallments]);


   const isOptionalObject = useMemo(() => {

    if (

      !Array.isArray(formik["values"]["allPaymentsMethods"]) ||

      formik["values"]["allPaymentsMethods"].length === 0

    )

      return;







    const currentComponent = formik["values"]["allPaymentsMethods"].find(

      (item) => {

        return item.type === "ach";

      }

    );



    if (!currentComponent ||!currentComponent._id) return;



    return {
      id:currentComponent?._id,
  coverConvenienceFee: currentComponent?.coverConvenienceFee ?? false,
      isOptional: currentComponent?.convenienceFeeInfo?.optional ?? false,

      message: currentComponent?.convenienceFeeInfo?.message,

      type: currentComponent?.type,

    };

  }, [formik["values"]]);

   useEffect(() => {

    if (!isOptionalObject?.isOptional) return;

    if (!key) return;

  

    if (formik.values[key] === undefined) {

      formik.setFieldValue(key, true);

    }

  }, [key, isOptionalObject]);

  const key = `${isOptionalObject?.id}`;



  const enableInstallments = useMemo(

    () => allowPaymentInstallment && enablePaymentInstallments,

    [allowPaymentInstallment, enablePaymentInstallments]

  );


  const [addNewCard, setAddNewCard] = useState(false);
  const [accountDetail, setAccountDetail] = useState({});
  const [achListing, setAchListing] = useState([]);
  const [checkAchSplit, setcheckAchSplit] = useState(false);
  const [checkCard, setCheckCard] = useState(false);
  const [setDefaultLoading, setSetDefaultLoading] = useState(false);
  const [canDeleteLoading, setCanDeleteLoading] = useState(null);
  const [stripePromise, setStripePromise] = useState(null);

  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();
  const dateTimeMask = maskDate();
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormate || "mm/dd/yyyy");
  const [confirmDeleteModal, setConfirmDeleteModal] = useState({
    open: false,
    id: null,
    message: "",
    connected: false,
  });
  const [instructionsModal, setInstructionsModal] = useState(false);


  useEffect(() => {
    if (selectedAch) {
      onPaymentValueChange(title, {
        target: {
          value: title,
          name: "paymentMethod",
        },
      });
      onPaymentValueChange(title, {
        target: {
          value: selectedAch.id,
          name: "ACH",
        },
      });
    }
    //eslint-disable-next-line
  }, [selectedAch]);

  useEffect(() => {
    if (selectedAch?.id) {
      formik.setFieldValue("SelectedProviderId", selectedAch.id)
    }

  }, [selectedAch])

  const [achNumberOne, setAchNumberOne] = useState("");
  const [achNumberTwo, setAchNumberTwo] = useState("");
  const [achSM, setAchSM] = useState("");


  const handelverifyAch = async (item) => {
    let data = {
      accountId: accountId ? accountId : formik?.values?.allData?.length > 0 ? formik?.values?.allData?.[0]?.Account?.id : formik?.values?.account_name?.id ?? "",
      achId: item?.id,
      firstAmount: achNumberOne ? achNumberOne : null,
      secondAmount: achNumberTwo ? achNumberTwo : null,
      smCode: achSM ? achSM : null,
    };

    if (data.firstAmount === null) delete data.firstAmount;
    if (data.secondAmount === null) delete data.secondAmount;
    if (data.smCode === null) delete data.smCode;

    const token = await getAccessTokenSilently();
    const res = await FinanceService.verifyAch(data, token)
      .then(() => {
        setAchNumberOne("");
        setAchNumberTwo("");
        setAchSM("");
        getAchCards();
        toastr.success("Success", "Account verified");
      })
      .catch((err) => {
        // console.log(err);
        toastr.error("Error", err?.data?.message || "Something went wrong");
      });
  };

  const onAccountChange = (event, name) => {
    console.log("onAccountChange called", name, event.target.value);
    setAccountDetail({
      ...accountDetail,
      [name]: event.target.value,
    });
    formik.setFieldValue(`account.${name}`, event.target.value);
  };
  const { accountTransaction } = useSelector((state) => state.CommonStates);

  const getAchCards = useCallback(async () => {
    const token = await getAccessTokenSilently();
    const res = await FinanceService.getACHCardsByAccountId(
      token,
      accountId ? accountId : formik?.values?.allData?.length > 0 ? formik?.values?.allData?.[0]?.Account?.id : !!accountTransaction ? accountTransaction?._id : formik?.values?.account_name?.id ?? "",
      source === "updatePayments" ? activeProvider : undefined
    );
    setAchListing(res.ach.data);
    formik.setFieldValue("ACHDetail", res.ach.data);
    const findDefaultCard = res.ach.data?.find((card) => card?.is_default);
    if (findDefaultCard) {
      setSelectedAch(findDefaultCard);
      formik.setFieldValue("selectedACH", findDefaultCard);
    } else if (res.ach.data?.length === 1) {
      setSelectedAch(res.ach.data[0]);
      formik.setFieldValue("selectedACH", res.ach.data[0]);
    }

  }, [getAccessTokenSilently, formik?.values?.account_name?.id, formik?.values?.allData]);

  useEffect(() => {
    if (!activeProvider || !achListing?.length) return;
    const findSelectedCard = achListing?.find(
      (item) => item.id === activeProvider
    );
    if (findSelectedCard) {
      setSelectedPaymentMethod({
        ...findSelectedCard,
        paymentMethodId,
      });
    }
  }, [activeProvider, achListing]);

  React.useEffect(() => {
    getAchCards();
  }, [getAchCards]);

  React.useEffect(() => {
    formik.setFieldValue("selectedACH", selectedAch);
  }, [selectedAch]);

  //Handle Submit ACH Account
  const onSaveAccount = async () => {
    const token = await getAccessTokenSilently();
    console.log("isStripe--->", isStripe);

    if (!isStripe) {
      console.log("isStripe---> ACH for OTHERS goes here");
      FinanceService.addACHAccount(
        token,
        accountId ? accountId : formik?.values?.allData?.length > 0 ? formik?.values?.allData?.[0]?.Account?.id : formik?.values?.account_name?.id ?? "",
        accountDetail
      )
        .then((res) => {
          getAchCards();
          formik.setFieldValue(`account.accountNumber`, "");
          formik.setFieldValue("account.routingNumber", "");
          formik.setFieldValue("account.accountType", "");
          formik.setFieldValue("account.nameOnAccount", "");

          if (formik?.values?.values?.[0]?.charge?.payment?.status === "declined" && formik?.values?.values?.[0]?.isRecurring) {
            setSelectedAch(res?.card)
          }
          setAddNewCard(false);
          setEnableAddCard && setEnableAddCard(false);
          toastr.success("Success", "ACH Added Successfully");
        })
        .catch((err) => {
          toastr.error(
            "Error",
            err?.data?.message ?? "Please enter valid card details"
          );
        });
    }
    else {
      console.log("isStripe---> ACH for stripe goes here");

      const token = await getAccessTokenSilently();
      const stripePromise = loadStripe(isStripe || "");
      console.log("stripePromise", stripePromise);
      const stripeP = await stripePromise;
      await FinanceService.checkStripeSetup(token, accountId ? accountId : formik?.values?.allData?.length > 0 ? formik?.values?.allData?.[0]?.Account?.id : formik?.values?.account_name?.id ?? "",)
        .then(async (res) => {

          console.log("res?.paymentIntent?.client_secret", res?.paymentIntent?.client_secret);
          const theIntent = res?.paymentIntent?.client_secret;

          if (res?.paymentIntent?.client_secret) {

            // console.log("accountDetail--->", accountDetail);
            // console.log("navigator:", navigator);

            // try {
            const {
              setupIntent,
              error: confirmError,
            } = await stripeP.confirmUsBankAccountSetup(
              theIntent,
              {
                payment_method: {
                  us_bank_account: {
                    routing_number: accountDetail.routing,
                    account_number: accountDetail.number,
                    account_holder_type: accountDetail.type, // Fixed: Stripe expects "individual" or "company", not account type like "checking"
                  },
                  billing_details: { name: accountDetail.name, email: undefined },
                },
                // mandate_data is typically required for ACH authorization
                mandate_data: {
                  customer_acceptance: {
                    type: "online",
                    online: {
                      // ip_address: navigator.ip_address,      // send from server if you prefer
                      user_agent: navigator.userAgent,
                    },
                  },
                },
              }
            );
            // console.log("confirm", setupIntent, confirmError);

            if (confirmError) {
              toastr.error("Error", confirmError?.message || "Something went wrong during confirmation");
              return;
            }

            // If successful, proceed to add the ACH account
            if (setupIntent) {
              await FinanceService.addACHAccountStripe(token, accountId ? accountId : formik?.values?.allData?.length > 0 ? formik?.values?.allData?.[0]?.Account?.id : formik?.values?.account_name?.id ?? "", setupIntent)
                .then((res) => {
                  toastr.success("Success", "ACH Added Successfully");
                  getAchCards();
                })
                .catch((err) => {
                  console.log("Something went wrong", err);
                  toastr.error(
                    "Error",
                    err?.data?.message || `Something went wrong ${err}`
                  );
                });
            }
            setAddNewCard(false);
            setEnableAddCard && setEnableAddCard(false);
            // } catch (stripeError) {
            // console.error("Stripe confirmUsBankAccountSetup error:", stripeError);
            // toastr.error("Error", stripeError.message || "Something went wrong during stripeError confirmation");
            return; // Prevent further execution
            // }
          }
        })
        .catch((err) => {
          console.log("Something went wrong", err);
          toastr.error("Error", err?.data || "Something went wrong here")
        });


    }
  }

  //handle delete ACH
  const checkCanDelete = async (id) => {
    if (canDeleteLoading) return;
    setCanDeleteLoading(id);
    const token = await getAccessTokenSilently();
    FinanceService.checkConnectedPaymentMethod({
      token,
      id,
      accountId: accountId ? accountId : formik?.values?.allData?.length > 0 ? formik?.values?.allData?.[0]?.Account?.id : formik?.values?.account_name?.id ?? ""
    }).then((response) => {
      if (response?.connected) {
        openConfirmDialog(id, "This payment method is linked to an installment or recurring payment. Are you sure you want to delete it?", true);
      } else {
        openConfirmDialog(id, "Do you want to delete this ACH?", false);
      }
    }).catch((err) => {
      toastr.error("Error", err?.data?.message || "Something went wrong");
    }).finally(() => {
      setCanDeleteLoading(null);
    });
  }

  const onDeleteAch = async (idx) => {
    const token = await getAccessTokenSilently();
    FinanceService.deleteAchCard(
      token,
      idx,
      accountId ? accountId : formik?.values?.allData?.length > 0 ? formik?.values?.allData?.[0]?.Account?.id : formik?.values?.account_name?.id ?? ""
    ).then(() => {
      getAchCards();
      if (selectedPaymentMethod?.id === idx) {
        setSelectedPaymentMethod(null);
      }
      toastr.success("Success", "ACH Deleted Successfully");
      closeConfirmDialog();
      if (confirmDeleteModal.connected) {
        window.dispatchEvent(new CustomEvent("save-transaction"));
      }
    }).catch((err) => {
      toastr.error("Error", err?.data?.message);
    });
  };


  const setCardDefaultHandler = async () => {
    if (selectedAch?.id) {
      const token = await getAccessTokenSilently();
      const data = {
        accountId: accountId ? accountId : formik?.values?.allData?.length > 0 ? formik?.values?.allData?.[0]?.Account?.id : formik?.values?.account_name?.id ?? "",
        achId: selectedAch?.id,
      };
      setSetDefaultLoading(true);
      await FinanceService.setDefaultAch(data, token)
        .then((res) => {
          toastr.success("Success", "Default card is checked!");
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        })
        .finally(() => {
          const timeOut = setTimeout(() => {
            setSetDefaultLoading(false);
          }, 2000);
          return () => {
            clearTimeout(timeOut);
          };
        });
      getAchCards();
    }
  };

  useEffect(() => {
    setCardDefaultHandler();
  }, [checkCard]);


  useEffect(() => {
    if (!formik?.values?.ach || !achListing?.length || formik?.values?.selectedACH) return;
    const findDefaultCard = achListing?.find((card) => card?.is_default);
    if (findDefaultCard) {
      setSelectedAch(findDefaultCard);
    } else if (achListing?.length === 1) {
      setSelectedAch(achListing[0]);
    }
  }, [formik?.values?.ach]);

  const openConfirmDialog = (id, message, connected) => {
    setConfirmDeleteModal((prev) => ({
      ...prev,
      open: true,
      message,
      id: id,
      connected,
    }));
  };

  const closeConfirmDialog = () => {
    setConfirmDeleteModal((prev) => ({
      ...prev,
      open: false,
      message: "",
      id: null,
      connected: false,
    }));
  };


  const calculateRemainingBalance = () => {
    return calculateTotalAmount() - calculateTotalPaidAmount();
  }

  const onSelectAch = (item) => {
    if (setDefaultLoading) return;
    if (item?.id === selectedAch?.id) {
      setSelected("");
      setSelectedAch("")
      source === "updatePayments" && setSelectedPaymentMethod(null);
    } else {
      setSelected("");
      setSelectedAch(item)
      source === "updatePayments" && setSelectedPaymentMethod({
        ...item,
        paymentMethodId,
      });
    }
  };


  console.log("isStripe 88888", isStripe);

  return (
    <>
      {formik?.values?.checkRecurring !== true && <div >

        {
          (formik?.values?.values?.[0]?.charge?.payment?.status !== "declined" && formik?.values?.values?.[0]?.isRecurring) &&
          <>
            {formik?.values?.values?.[0]?.is_splitted && <div className="left-side px-0 my-4">

              <div className="d-flex">
                <MyCheckbox
                  name={"default"}
                  title=""
                  value={checkAchSplit}
                  onClick={(e) => {
                    formik.setFieldValue(
                      `checkAchSplit`,
                      !checkAchSplit
                    );
                    setcheckAchSplit(!checkAchSplit);
                  }}
                />
                <LabelField title="Use for Split Payment" />
              </div>
            </div>}
          </>
        }
        <div className="form-row col-sm-12 px-0 mt-4" style={{ alignItems: "flex-start" }}>
          <div className="d-flex col-sm-7" style={{ alignSelf: "flex-start" }}>
            <div className="cards-radio font-16">
              {achListing?.map((item) => {
                const isSelected = source === "updatePayments" ? selectedPaymentMethod?.id === item.id : selectedAch?.id === item.id;
                return (
                <div
                  key={item.id}
                  className={`${setDefaultLoading ? "disabled-card" : ""}`}
                >
                  <div
                    data-id={item.id}
                    className={`d-flex align-items-start ${isSelected ? "selected-card" : ""}`}
                    style={{ marginBottom: "10px" }}
                  >
                    <MyCheckbox
                      name={`ach-select-${item.id}`}
                      checked={isSelected}
                      title=""
                      handlechange={() => onSelectAch(item)}
                    />
                    <p style={{ margin: 0, cursor: "pointer" }} onClick={() => onSelectAch(item)}>
                      {`${item.nameOnAccount ? item.nameOnAccount : ""} ${item.accountNumber ? "/ " + item.accountNumber : ""}`}
                      {canDeleteLoading === item.id ? (
                        <span className="spinner spinner-black"></span>
                      ) : (
                        <DeleteSvgComponent
                          color={"gray"}
                          onClick={(e) => {
                            e.stopPropagation();
                            checkCanDelete(item.id);
                          }}
                          className="cursor-pointer"
                        />
                      )}
                    </p>
                  </div>
                  {item?.status !== "verified" && (
                    <div>
                      <div
                        style={{
                          display: "flex",
                          height: "auto",
                        }}
                      > <QuestionIcon width={20} style={{ marginTop: "0.5rem", marginRight: "0.5rem", cursor: "pointer" }} onClick={() => setInstructionsModal(true)} />
                        <input
                          style={{
                            width: "40px",
                            height: "30px",
                            marginRight: "1rem",
                            border: "1px solid #00000042",
                            background: "transparent",
                            color: "#000000",
                            textAlign: "center",
                            marginTop: "0.5rem",
                          }}
                          type={"tel"}
                          maxlength="2"
                          onChange={(event) => setAchNumberOne(event.target.value)}
                        ></input>
                        <input
                          style={{
                            width: "40px",
                            height: "30px",
                            marginRight: "1rem",
                            border: "1px solid #00000042",
                            background: "transparent",
                            color: "#000000",
                            textAlign: "center",
                            marginTop: "0.5rem",
                          }}
                          type={"tel"}
                          maxlength="2"
                          onChange={(event) => setAchNumberTwo(event.target.value)}
                        ></input>
                        <p style={{ marginRight: "1rem" }}>OR</p>
                        <input
                          style={{
                            width: "100px",
                            height: "30px",
                            marginRight: "1rem",
                            border: "1px solid #00000042",
                            background: "transparent",
                            color: "#000000",
                            textAlign: "center",
                            marginTop: "0.5rem",
                          }}
                          // type={"tel"}
                          maxlength="6"
                          minLength="6"
                          placeholder="SMxxxx"
                          onChange={(event) => setAchSM(event.target.value)}
                        ></input>
                        <MyButton
                          style={{
                            height: "30px",
                          }}
                          content={"Verify"}
                          onClick={() => handelverifyAch(item)}
                        />

                      </div>
                    </div>
                  )}
                </div>
                );
              })}
            </div>
          </div>
          <div className="right-side px-0" style={{ minWidth: "216px" }}>
            {!!achListing?.length && (
              <div className="d-flex mb-2">
                <MyCheckbox
                  name={"default"}
                  checked={source === "updatePayments" ? selectedPaymentMethod?.is_default : selectedAch?.is_default}
                  title=""
                  value={checkCard}
                  onClick={(e) => {
                    setCheckCard(!checkCard);
                  }}
                />
                <LabelField title="Set as default ACH" />
              </div>
            )}
            {!!achListing?.length && enableInstallments && (
              <div className="d-flex mb-2"
                style={(formik.values?.allowCreditInstallment || formik.values?.ach_future_enabled || formik.values?.cc_future_enabled) ? { opacity: 0.7, pointerEvents: "none" } : {}}
              >
                <MyCheckbox
                  name={"Installments-pay"}
                  checked={formik.values.allowAchInstallment}
                  title=""
                  onClick={(e) => {
                    if (!formik?.values?.creditCardAmount) {
                      formik.setFieldValue("ach", calculateRemainingBalance());
                    } else {
                      formik.setFieldValue("allowCreditInstallment", false);
                      formik.setFieldValue("installmentCreditDetails", {
                        cycle: "",
                        frequency: "",
                        startInstallment: new Date(),
                      });
                    }
                    formik.setFieldValue("allowAchInstallment", e.target.checked);
                  }}
                  disabled={formik.values?.allowCreditInstallment || formik.values?.ach_future_enabled || formik.values?.cc_future_enabled}
                />
                <LabelField title="Pay in Installments" />
              </div>
            )}
            {!!achListing?.length && isOptionalObject?.coverConvenienceFee && isOptionalObject?.isOptional && (
              <div className="d-flex mb-2">
                <MyCheckbox
                  name={key}
                  checked={formik.values?.[key]}
                  onClick={(e) => {
                    formik.setFieldValue(key, e.target.checked);
                  }}
                />
                <LabelField title="Convenience Fee" />
              </div>
            )}
            {!isMemberDetails && (
            <div className="d-flex mb-2"
              style={(formik.values?.allowCreditInstallment || formik.values?.allowAchInstallment || formik.values?.cc_future_enabled || formik?.values?.values?.[0]?.isRecurring) ? { opacity: 0.7, pointerEvents: "none" } : {}}
            >
              <MyCheckbox
                name="ach_future_enabled"
                title=""
                checked={formik.values?.ach_future_enabled}
                onClick={(e) => {
                  formik.setFieldValue("ach_future_enabled", e.target.checked);
                  if (!e.target.checked) formik.setFieldValue("ach_future_date", null);
                }}
                disabled={formik.values?.allowCreditInstallment || formik.values?.allowAchInstallment || formik.values?.cc_future_enabled || formik?.values?.values?.[0]?.isRecurring}
              />
              <LabelField title="Future Payment" />
            </div>
            )}
          </div>
        </div>
        <div
          className="my-5 d-flex col-sm-7"
          onClick={() => {
            setEnableAddCard && setEnableAddCard((prev) => !prev);
            setAddNewCard((prev) => !prev);
          }}
        >
          <div className="add-new-payment-info">
            <span className="add-icon">
              <AddIcon />
            </span>
            <span className="add">Add New ACH</span>
          </div>
        </div>
        {addNewCard && (
          <div className="row my-5 pb-5">
            <div className="col-sm-4 pr-3 mt-2">
              {isStripe ? (
                <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'flex-start', flexDirection: 'column' }}>
                  <label style={{
                    fontSize: '14px',
                    fontFamily: fontConfig.FinanceACHTextFont.family,
                    textAlign: 'start',
                    fontWeight: '500'
                  }}>
                    <span>Account holder type</span>
                    <label style={{ fontWeight: "500", color: "red" }}> *</label>
                  </label>
                  <select
                    value={formik.values.account?.type || ''}
                    onChange={(event) => onAccountChange(event, "type")}
                    style={{
                      width: '100%',
                      borderRadius: '5px',
                      border: '1px solid #F3F6F9',
                      background: '#F3F6F9',
                      height: '48.13px',
                      paddingLeft: '16px',
                      fontSize: '14px',
                      fontFamily: fontConfig.FinanceACHText2Font.family,
                      boxSizing: 'border-box',
                      marginTop: '-3px',
                      color: '#3F4254'
                    }}
                  >
                    <option value="">Select Account Holder Type</option>
                    <option value="individual">Individual</option>
                    <option value="company">Company</option>
                  </select>
                </div>
              ) : (
                <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'flex-start', flexDirection: 'column' }}>
                  <label style={{
                    fontSize: '14px',
                    fontFamily: fontConfig.FinanceACHTextFont.family,
                    textAlign: 'start',
                    fontWeight: '500'
                  }}>
                    <span>Account holder type</span>
                    <label style={{ fontWeight: "500", color: "red" }}> *</label>
                  </label>
                  <select
                    value={formik.values.account?.type || ''}
                    onChange={(event) => onAccountChange(event, "type")}
                    style={{
                      width: '100%',
                      borderRadius: '5px',
                      border: '1px solid #F3F6F9',
                      background: '#F3F6F9',
                      height: '48.13px',
                      paddingLeft: '16px',
                      fontSize: '14px',
                      fontFamily: fontConfig.FinanceACHText2Font.family,
                      boxSizing: 'border-box',
                      marginTop: '-3px',
                      color: '#3F4254'
                    }}
                  >
                    <option value="">Select Account Holder Type</option>
                    <option value="checking">checking</option>
                    <option value="savings">savings</option>
                  </select>
                </div>
              )}
            </div>
            <div className="col-sm-4 pr-0 mt-2">
              <InputField
                mandatory
                {...{
                  formik,
                  title: "Account number",
                  name: "account.accountNumber",
                  type: "string",
                  minlength: "16",
                  maxLength: "16",
                }}
                id="myInput"
                handleChange={(event) => onAccountChange(event, "number")}
              />
            </div>
            <div className="col-sm-4 pr-0 mt-2">
              <InputField
                mandatory
                {...{
                  formik,
                  title: "Routing number",
                  name: "account.routingNumber",
                  type: "string",
                  minlength: "16",
                  maxLength: "16",
                }}
                handleChange={(event) => onAccountChange(event, "routing")}
                id="myInput"
              />
            </div>
            <div className="col-sm-4 pr-0 mt-2">
              <InputField
                mandatory
                {...{
                  formik,
                  title: "Name on account",
                  name: `account.nameOnAccount`,
                  placeholder: "",
                }}
                handleChange={(event) => onAccountChange(event, "name")}
              />
            </div>
            <div
              className="col-sm-4"
              style={{
                marginTop: "3rem",
              }}
            >
              <MyButton
                content={"Save Account"}
                style={{ width: 120 }}
                onClick={onSaveAccount}
              />
            </div>
          </div>
        )}
      </div>}
      {(formik.values.allowAchInstallment && enableInstallments) && (
        <AddInstallmentsPayment
          formik={formik}
          formikKey="installmentAchDetails"
          installmentFieldLabel="Installments"
          dateFieldLabel="First payment date"
          dateRequired={true}
        />
      )}
      {formik.values?.ach_future_enabled && (
        <div className="row my-5 add-installment-payment">
          <div className="col-12 col-md-6">
            <LabelField title="Payment Date" mandatory />
            <DatePicker
              showIcon
              popperPlacement="top"
              popperProps={{ strategy: "fixed" }}
              placeholderText={placeholderFormat}
              dateFormat={dateFormate}
              selected={formik.values?.ach_future_date ? new Date(formik.values.ach_future_date) : null}
              onChange={(date) => formik.setFieldValue("ach_future_date", date)}
              minDate={new Date()}
              customInput={
                <MaskedInput
                  pipe={autoCorrectedDatePipe}
                  mask={dateTimeMask}
                  keepCharPositions={true}
                  guide={true}
                />
              }
            />
          </div>
        </div>
      )}
      <AlertDialog
        open={confirmDeleteModal.open}
        onDecline={closeConfirmDialog}
        onAccept={() => {
          onDeleteAch(confirmDeleteModal.id);
        }}
        title={"Are you sure?"}
        description={confirmDeleteModal.message}
      />
      <AlertDialog
        open={instructionsModal}
        // onDecline={() => setInstructionsModal(false)}
        onAccept={() => setInstructionsModal(false)}
        title={"ACH Verification Instructions"}
        description={"To verify your ACH account, you can either enter the micro-deposit amounts that were sent to your account or 6-digit code in the statement descriptor of this deposit."}
      />
    </>
  );
};
export const ACHHeader = ({ formik, setSelectedAch, ...props }) => {
  const { expanded, current } = props;

  const currency = getCurrency();


  const preventMinus = (e) => {
    const characterCode = e.key;
    if (characterCode === "Backspace") return;

    const characterNumber = Number(characterCode);
    if (characterNumber >= 0 && characterNumber <= 9) {
      if (e.currentTarget.value && e.currentTarget.value.length) {
        return;
      } else if (characterNumber === 0) {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
    }
  };
  const handlefieldClick = (e) => {
    if (e.stopPropagation && expanded === true) {
      e.stopPropagation();
    }
  };

  const handleOnChange = (event) => {
    formik.setFieldValue("ach", event.target.value);
    if (!event.target.value) {
      setSelectedAch("");
    }
  };

  useEffect(() => {
    if (formik.values.ach === "") {
      formik.setFieldValue("ach_payment", undefined)
    }

  }, [formik.values?.ach])

  useEffect(() => {
    if (expanded === true && formik?.values?.checkRecurring === true) {
      toastr.error('You can select only one payment method')
    }

    if (expanded === true && formik?.values?.checkSplitting === true) {
      toastr.error('You can select only one payment method')
    }

  }, [expanded])

  // useEffect(() => {
  //   if (formik?.values?.values?.[0]?.isRecurring && formik.values.actual_total) {
  //     handleOnChange(formik.values.actual_total)
  //   }

  // }, [formik?.values?.values])


  return (
    <div
      className={
        expanded === false && current?.includes("ach") === true
          ? "accordion-header achPayment"
          : expanded === false
            ? "accordion-payment-header achPayment"
            : expanded === true
              ? "accordion-header achPayment"
              : "accordion-header-payment achPayment"
      }
    >
      <div className="d-flex">
        <LabelField title="ACH" />
      </div>
      <div
        className={
          expanded === false && current?.includes("ach")
            ? "custom-expand dollor-icon col-sm-3 nonexpanded-amount "
            : "col-sm-2"
        }
      >
        {expanded === false &&
          // current?.includes("ach") &&
          formik?.values?.ach ? (
          <div className="cash-non-expanded">

            <span>{currency}</span>
            {/* <span>{formik.values?.ach}.00</span> */}
            <span>{isNaN(formik.values?.ach) ? "0.00" : thousands((+formik.values?.ach).toFixed(2))}</span>
          </div>
        ) : current?.includes("ach") && expanded === true ? (
          <>
            {
              formik?.values?.values?.[0]?.isRecurring || formik?.values?.values?.[0]?.charge?.payment?.status === "declined" ? currency + thousands((+formik?.values?.actual_total).toFixed(2)) :
                <InputField
                  {...{
                    formik,
                    title: "none",
                    name: `val`,
                    style: { background: "#ffff", border: "none" },
                    value: formik.values?.ach,
                    placeholderIcon: (
                      <span
                        className="align-self-center px-4"
                        style={{ color: "black" }}
                      >
                        {currency}
                      </span>
                    ),
                  }}
                  // disbaled={formik?.values?.values?.[0]?.isRecurring}
                  handleFocus={(e) => handlefieldClick(e)}
                  paymentInput="paymentInput"
                  // onKeyDown={preventMinus}
                  handleChange={(event) => handleOnChange(event)}
                />
            }
          </>
        )

          : (
            ""
          )}
      </div>
    </div>
  );
};